// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DWDButton_type_1__tGWWW {
    font-size: 14px;
    background-color: #0047BA;
    border: unset !important;
    padding: 5px 10px;
    border-radius: 4px;
    box-shadow: unset !important;

    &:hover {
        background-color: #00428f;
    }

    &:disabled {
        pointer-events: none;
        background-color: #e9e9e9;
        color: #a5a5a5
    }

} 

.DWDButton_type_2__xTpn\\+ {
    font-size: 14px;
    background-color: unset;
    color: gray;
    text-decoration: underline;
    border: unset !important;
    padding: 0px 10px;
    border-radius: 4px;
    box-shadow: unset !important;

    &:hover {
       color: #00428f;
       background-color: unset;
       text-decoration: underline;
    }

    &:disabled {
        pointer-events: none;
        background-color: unset;
        color: #a5a5a5
    }

} 

.DWDButton_type_3__d9xok {
    font-size: 14px;
    background-color: #0047BA;
    border: unset !important;
    padding: 6px 10px;
    border-radius: 4px;
    box-shadow: unset !important;

    &:hover {
        background-color: #00428f;
    }

    &:disabled {
        pointer-events: none;
        background-color: #e9e9e9;
        color: #a5a5a5
    }

} `, "",{"version":3,"sources":["webpack://./src/Common/Components/DWDButton/DWDButton.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,yBAAyB;IACzB,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;;IAE5B;QACI,yBAAyB;IAC7B;;IAEA;QACI,oBAAoB;QACpB,yBAAyB;QACzB;IACJ;;AAEJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,0BAA0B;IAC1B,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;;IAE5B;OACG,cAAc;OACd,uBAAuB;OACvB,0BAA0B;IAC7B;;IAEA;QACI,oBAAoB;QACpB,uBAAuB;QACvB;IACJ;;AAEJ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;;IAE5B;QACI,yBAAyB;IAC7B;;IAEA;QACI,oBAAoB;QACpB,yBAAyB;QACzB;IACJ;;AAEJ","sourcesContent":[".type_1 {\n    font-size: 14px;\n    background-color: #0047BA;\n    border: unset !important;\n    padding: 5px 10px;\n    border-radius: 4px;\n    box-shadow: unset !important;\n\n    &:hover {\n        background-color: #00428f;\n    }\n\n    &:disabled {\n        pointer-events: none;\n        background-color: #e9e9e9;\n        color: #a5a5a5\n    }\n\n} \n\n.type_2 {\n    font-size: 14px;\n    background-color: unset;\n    color: gray;\n    text-decoration: underline;\n    border: unset !important;\n    padding: 0px 10px;\n    border-radius: 4px;\n    box-shadow: unset !important;\n\n    &:hover {\n       color: #00428f;\n       background-color: unset;\n       text-decoration: underline;\n    }\n\n    &:disabled {\n        pointer-events: none;\n        background-color: unset;\n        color: #a5a5a5\n    }\n\n} \n\n.type_3 {\n    font-size: 14px;\n    background-color: #0047BA;\n    border: unset !important;\n    padding: 6px 10px;\n    border-radius: 4px;\n    box-shadow: unset !important;\n\n    &:hover {\n        background-color: #00428f;\n    }\n\n    &:disabled {\n        pointer-events: none;\n        background-color: #e9e9e9;\n        color: #a5a5a5\n    }\n\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"type_1": `DWDButton_type_1__tGWWW`,
	"type_2": `DWDButton_type_2__xTpn+`,
	"type_3": `DWDButton_type_3__d9xok`
};
export default ___CSS_LOADER_EXPORT___;
